import React from 'react';
import { Link } from 'react-router-dom';

import { Container } from './styles';

import logo from '../../assets/logo.png';

function Navbar() {
    return (
        <Container>
            <figure>
                <Link to="/">
                    <img src={logo} alt="" />
                </Link>
            </figure>

            <ul>
                <li>
                    <a href="https://discord.com/oauth2/authorize?client_id=438849443949969408&scope=bot&permissions=0">
                        Add to discord
                    </a>
                </li>
                <li>
                    <Link to="/commands">
                        Commands
                    </Link>
                </li>
                <li>
                    <a href="https://top.gg/bot/438849443949969408/vote">
                        Vote
                        </a>
                </li>
                <li>
                    <a href="https://discord.gg/Deuhd45">
                        Support
                        </a>
                </li>
                <li>Donate</li>
            </ul>

        </Container>
    );
}

export default Navbar;